import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import {
  DESTINATIONS,
  POPULAR_AIRLINES,
  WHY_CHOOSE_US,
  airlineLogo,
  formatINR,
} from "@/mock";

// ---------------- Why Choose Us ----------------
export const WhyChooseUs = () => (
  <section className="mx-auto max-w-7xl px-4 pt-14">
    <h2 className="text-center text-2xl font-extrabold text-slate-800 md:text-[28px]">
      Why <span className="text-[#1B1F5B]">Choose Us ?</span>
    </h2>
    <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {WHY_CHOOSE_US.map((w, i) => (
        <div
          key={i}
          className="group rounded-2xl border border-slate-100 bg-white p-6 text-center shadow-[0_6px_24px_rgba(27,31,91,0.07)] transition-all duration-300 hover:-translate-y-1.5 hover:border-[#F5B32B]/50 hover:shadow-[0_16px_40px_rgba(27,31,91,0.14)]"
        >
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#FFF9EC] transition-transform duration-300 group-hover:scale-110">
            <img src={w.img} alt={w.title} className="h-12 w-12 object-contain" />
          </div>
          <h3 className="mt-4 text-[15px] font-extrabold uppercase tracking-wide text-[#1B1F5B]">
            {w.title}
          </h3>
          <p className="mt-2 text-[13px] leading-relaxed text-slate-500">{w.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

// ---------------- Popular Destinations ----------------
export const PopularDestinations = () => {
  const navigate = useNavigate();
  return (
    <section className="mx-auto max-w-7xl px-4 pt-14">
      <div className="flex items-end justify-between">
        <h2 className="text-2xl font-extrabold text-slate-800 md:text-[28px]">
          Popular <span className="text-[#1B1F5B]">Destinations</span>
        </h2>
        <button
          onClick={() => navigate("/package")}
          className="flex items-center gap-1 text-sm font-bold text-[#1B1F5B] hover:underline"
        >
          View All <ArrowRight className="h-4 w-4" />
        </button>
      </div>
      <div className="no-scrollbar -mx-4 mt-6 flex gap-5 overflow-x-auto px-4 pb-4 snap-x">
        {DESTINATIONS.map((d) => (
          <button
            key={d.city}
            onClick={() => navigate(`/package?city=${d.city}`)}
            className="group relative h-64 w-[230px] shrink-0 snap-start overflow-hidden rounded-2xl text-left shadow-[0_8px_28px_rgba(27,31,91,0.14)]"
          >
            <img
              src={d.img}
              alt={d.city}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F2E]/85 via-transparent to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-4">
              <h3 className="text-lg font-extrabold text-white">{d.city}</h3>
              <p className="text-xs font-medium text-white/80">Tour Packages</p>
              <p className="mt-1.5 text-[13px] font-bold text-[#F5B32B]">
                Starting at INR {formatINR(d.price).slice(1)}
              </p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

// ---------------- Popular Airlines ----------------
export const PopularAirlines = () => (
  <section className="mx-auto max-w-7xl px-4 pt-14">
    <h2 className="text-2xl font-extrabold text-slate-800 md:text-[28px]">
      Popular <span className="text-[#1B1F5B]">Airlines</span>
    </h2>
    <div className="no-scrollbar -mx-4 mt-6 flex gap-4 overflow-x-auto px-4 pb-3">
      {POPULAR_AIRLINES.map((a) => (
        <div
          key={a.code + a.name}
          className="group flex w-40 shrink-0 flex-col items-center rounded-2xl border border-slate-100 bg-white px-4 py-5 shadow-[0_4px_18px_rgba(27,31,91,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(27,31,91,0.13)]"
        >
          <img
            src={airlineLogo(a.code, 60)}
            alt={a.name}
            loading="lazy"
            className="h-11 w-11 object-contain transition-transform duration-300 group-hover:scale-110"
          />
          <p className="mt-3 text-center text-[13px] font-semibold text-slate-700">
            {a.name}
          </p>
        </div>
      ))}
    </div>
  </section>
);
